<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
          style="cursor:pointer"
          >view_headline</i
        >
        <i id="sidebar-toggle"
          class="material-icons sidebar-toggle-icon"
          :style="{ left: isSidebar ? '4px' : '203px' }"
          @click="isSidebar =  !isSidebar"
          >{{ isSidebar ? 'chevron_right' : 'chevron_left' }}</i
        >
        <app-navbar :isSidebar="isSidebar"></app-navbar>
        <div class="mt46">
          <DashboardView  />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import DashboardView from "../../commonPages/DashboardView"
import DashboardView from "../../commonPages/NewDashbord"
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";


export default {
  data: () => ({
    isSidebar: false,

  }),

  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
     DashboardView
  },

};
</script>

<style scoped>

.myNavbar {
  color: rgb(255, 255, 255);
}
.mt46 {
  margin-top: 46px !important;
}
#sidebar-toggle {
  position: absolute;
  top: 0px;
  z-index: 100;
  transition: all 0.3s ease;
  cursor: pointer;
  background: #06a6e0;
  color: white;
  padding: 8px;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.sidebar-toggle-icon {
  font-size: 24px;
  width: 40px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

/* .sidebar-toggle-icon:hover {
  background: #0596c7;
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
} */

@media (max-width: 768px) {
  #sidebar-toggle {
    display: none;
  }
  
}

</style>
